import { XmarkSolid } from '@allocab/allocab-icons';
import { twJoin } from 'tailwind-merge';

import { t } from '../../services/translation/translation';

type Props = {
  title?: string;
  onClose?: () => void;
};

export const ModalHeader = ({ title, onClose }: Props) => {
  return (
    <div className={twJoin(!!title && 'flex items-start justify-between p-4 border-b rounded-t dark:border-gray-600')}>
      {title ? <h3 className="text-xl font-semibold text-gray-900 dark:text-white pr-6">{title}</h3> : null}
      {onClose ? (
        <button
          type="button"
          className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          onClick={() => onClose()}
        >
          <XmarkSolid width={12} height={12} className="fill-current" />
          <span className="sr-only">{t('modal.close')}</span>
        </button>
      ) : null}
    </div>
  );
};
